import React, { FC } from 'react';
import styled from 'styled-components';

import { Player, Match, PlayerResult } from '../../../../database.schema';

const Table = styled.table`
  table-layout: auto;
  width: 100%;
  border-collapse: collapse;
  color: white;
  background: transparent;
  font-size: 1rem;
  margin: 0 0.5rem;
`;

const TableHeader = styled.th`
  text-align: center;
  color: black;
  font-weight: bold;
`;

const TableCell = styled.td`
  text-align: center;
  padding: 0.25rem 0 0;
`;

export const TableRowBorder = styled.tr<{ colour?: string | null }>`
  color: ${(props) => props.colour || 'black'};
  font-weight: bold;
`;

type PlayerInfoProps = {
  recordedMatch: Match;
  players: Array<Player>;
};

export const PlayerInfo: FC<PlayerInfoProps> = ({ recordedMatch, players }): JSX.Element => {
  return (
    <div>
      <Table data-testid="scorecard-handicap-table">
        <thead>
          <tr>
            <TableHeader></TableHeader>
            <TableHeader>Player</TableHeader>
            <TableHeader>Handicap</TableHeader>
            <TableHeader>Shots</TableHeader>
          </tr>
        </thead>
        <tbody>
          {recordedMatch.team1.players.map((player: PlayerResult, index: number) => (
            <TableRowBorder colour="red" key={`hcaps-t1-${player.playerId}`} data-testid={`t1-hcaps-${player.playerId}`}>
              <TableCell>{`P${index + 1}`}</TableCell>
              <TableCell>{players.find((playerA: Player) => playerA.id === player.playerId)?.nickName}</TableCell>
              <TableCell>{player.round.individualHandicap}</TableCell>
              <TableCell>{player.round.shotsReceived}</TableCell>
            </TableRowBorder>
          ))}
          {recordedMatch.team2.players.map((player: PlayerResult, index: number) => (
            <TableRowBorder colour="blue" key={`hcaps-t2-${player.playerId}`} data-testid={`t2-hcaps-${player.playerId}`}>
              <TableCell>{`P${index + 1 + recordedMatch.team1.players.length}`}</TableCell>
              <TableCell>{players.find((playerA: Player) => playerA.id === player.playerId)?.nickName}</TableCell>
              <TableCell>{player.round.individualHandicap}</TableCell>
              <TableCell>{player.round.shotsReceived}</TableCell>
            </TableRowBorder>
          ))}
        </tbody>
      </Table>
    </div>
  );
};
